import { Builder, withChildren } from '@builder.io/react'

const CustomWrapper = (props) => {
  const { children, onClickFunction = '', wrapperClasses = '' } = props

  const handleClick = () => {
    try {
      if (onClickFunction) {
        new Function(onClickFunction)()
      }
    } catch (err) {
      console.error('[CustomWrapper] Error running custom code:', err)
    }
  }

  return (
    <div onClick={handleClick} className={wrapperClasses} style={{ cursor: 'pointer' }}>
      {children}
    </div>
  )
}

const WrapperWithChildren = withChildren(CustomWrapper)

Builder.registerComponent(WrapperWithChildren, {
  name: 'CustomWrapper',
  canHaveChildren: true,
  inputs: [
    {
      name: 'onClickFunction',
      type: 'string',
      friendlyName: 'Run JS Code on Click',
      helperText: 'Enter raw JavaScript code (e.g. console.log("clicked"))',
    },
    {
      name: 'wrapperClasses',
      type: 'string',
      friendlyName: 'Tailwind Classes for Wrapper',
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Text',
        options: {
          text: 'Click me (custom JS)',
        },
      },
    },
  ],
})

export default CustomWrapper
